import {
  IconButton,
  NextIcon,
  PreviousIcon,
  TablePagination,
  Typography,
  useBreakpointDown,
} from '@all-manager/design-system-v2';
import { useProvidersPagination } from './useProvidersPagination';

type Props = {
  count: number;
  /** 0-based. */
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

const mobilePaginationStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px',
  minHeight: 48,
};

const pageLabelStyle: React.CSSProperties = {
  userSelect: 'none',
};

export default function ProvidersPagination(props: Props) {
  const isMobile = useBreakpointDown('sm');
  const hook = useProvidersPagination(props);

  if (isMobile) {
    return (
      <div style={mobilePaginationStyle}>
        <IconButton
          tooltip="Page précédente"
          size="medium"
          disabled={hook.isFirstPage}
          onClick={hook.handlePrevious}
        >
          <PreviousIcon />
        </IconButton>

        <span style={pageLabelStyle}>
          <Typography variant="body2">
            {hook.mobilePageLabel}
          </Typography>
        </span>

        <IconButton
          tooltip="Page suivante"
          size="medium"
          disabled={hook.isLastPage}
          onClick={hook.handleNext}
        >
          <NextIcon />
        </IconButton>
      </div>
    );
  }

  return (
    <TablePagination
      count={props.count}
      page={props.page}
      rowsPerPage={props.rowsPerPage}
      rowsPerPageOptions={hook.rowsPerPageOptions}
      onPageChange={props.onPageChange}
      onRowsPerPageChange={props.onRowsPerPageChange}
      labelRowsPerPage="Par page"
      labelDisplayedRows={hook.formatDisplayedRows}
      getItemAriaLabel={hook.getItemAriaLabel}
    />
  );
}
